import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { DialogService } from '~console/app/~shared/services/dialog.service';
import { Router } from '@angular/router';
import { ROUTES } from '~console/app/~shared/constants/routes.constants';

@Component({
  selector: 'admin-migration-modal',
  standalone: false,
  templateUrl: './admin-migration-modal.component.html',
  styleUrl: './admin-migration-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminMigrationModalComponent extends BaseAuthComponent {
  private readonly _dialogService = inject(DialogService);
  private readonly _router = inject(Router);

  currentUser = toSignal(this._authFacade.currentUser$, {
    initialValue: null
  });

  managerName = computed(() => {
    const currentUser = this.currentUser();
    if (!currentUser) return 'votre gestionnaire';
    const manager = currentUser.organization.manager;
    if (!manager) return 'votre gestionnaire';
    const fullName =
      [manager.firstName, manager.lastName].filter(Boolean).join(' ') ||
      manager.fullName ||
      manager.username ||
      manager.email;
    return fullName || 'votre gestionnaire';
  });

  organizationName = computed(() => {
    const currentUser = this.currentUser();
    return currentUser?.organization?.name || 'votre entreprise';
  });

  goToOnboardingMigration(): void {
    this._router.navigateByUrl(ROUTES.migrationOnboarding);
    this._dialogService.closeAll();
  }
}
